import React, { useState } from "react";
import Reviews from "./Reviews";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { EffectCoverflow, Pagination, Navigation } from "swiper";

import { CONTACT } from "../config/site";

export const Testimonial = ({ title, section, id }) => {
  const [review, setReview] = useState(false);
  const [uname, setUname] = useState("");
  const [company, setCompany] = useState("");
  const [position, setPosition] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [status, setStatus] = useState("idle"); // idle | sending | ok | error
  const [errorMsg, setErrorMsg] = useState("");

  const close = () => {
    setReview(false);
    setStatus("idle");
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!uname.trim() || !position.trim() || !message.trim()) {
      setStatus("error");
      setErrorMsg("Please fill in name, position and your review.");
      return;
    }

    setStatus("sending");
    try {
      const res = await fetch(CONTACT.formEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user: uname,
          email: "",
          position,
          company,
          message,
          website,
          source: "testimonial-" + (id || "x"),
          page:
            typeof window !== "undefined" ? window.location.pathname : "",
          type: "review",
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setStatus("ok");
        setUname("");
        setCompany("");
        setPosition("");
        setMessage("");
        setTimeout(close, 3000);
      } else {
        setStatus("error");
        setErrorMsg(
          "Could not submit. Please email " + CONTACT.email + "."
        );
      }
    } catch (error) {
      setStatus("error");
      setErrorMsg("Network error. Please try again later.");
    }
  };

  return (
    <div className="testimonials" style={{ marginTop: "-50px" }}>
      <h1 style={{ marginBottom: "-25px" }}>{title}</h1>

      <Swiper
        slidesPerView={4}
        spaceBetween={25}
        loop={true}
        centerSlide={true}
        fade={true}
        grabCursor={true}
        pagination={{ clickable: true, dynamicBullets: true }}
        navigation={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          520: { slidesPerView: 2 },
          950: { slidesPerView: 3 },
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="mySwiper"
      >
        {section.map((data, i) => (
          <SwiperSlide key={i}>
            <Reviews
              rname={data.rname}
              rtitle={data.rtitle}
              content={data.content}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="subheading">
        <h2>We would love to hear your experience with Cloudare</h2>
        <button
          type="button"
          className="btn"
          onClick={() => setReview(true)}
        >
          Leave a Review
        </button>
      </div>
      {review && (
        <div className="feedback">
          <div className="popup">
            <div className="popup-inner">
              <button
                type="button"
                className="close-btn"
                onClick={close}
                aria-label="Close"
              >
                X
              </button>
              {status === "ok" ? (
                <h3>
                  Thanks for your review!
                  <br />
                  We will get back to you.
                </h3>
              ) : (
                <form className="contact" onSubmit={handleSubmit} noValidate>
                  <h2>Review</h2>

                  {/* Honeypot */}
                  <input
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    style={{
                      position: "absolute",
                      left: "-10000px",
                      top: "-10000px",
                      width: 1,
                      height: 1,
                      opacity: 0,
                    }}
                    aria-hidden="true"
                  />

                  <input
                    type="text"
                    className="field"
                    placeholder="Name"
                    onChange={(e) => setUname(e.target.value)}
                    value={uname}
                    required
                  />
                  <input
                    type="text"
                    className="field"
                    placeholder="Position"
                    onChange={(e) => setPosition(e.target.value)}
                    value={position}
                    required
                  />
                  {id === 1 && (
                    <input
                      type="text"
                      className="field"
                      placeholder="Company"
                      onChange={(e) => setCompany(e.target.value)}
                      value={company}
                    />
                  )}
                  <textarea
                    placeholder="Message"
                    className="field"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    required
                  />
                  {status === "error" && (
                    <p className="error-message" style={{ color: "#c0392b" }}>
                      {errorMsg}
                    </p>
                  )}
                  <button
                    type="submit"
                    className="btn"
                    disabled={status === "sending"}
                  >
                    {status === "sending" ? "Submitting…" : "Submit"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Testimonial;
